import { render } from "./ConfirmDeleteOverlay.vue?vue&type=template&id=38f29c78"
import script from "./ConfirmDeleteOverlay.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__